import { Button } from "@@/shared/components/button";
import { Column } from "@@/shared/components/column";
import { Row } from "@@/shared/components/row";
import { VerticalDivider } from "@@/shared/dividers";
import { Span } from "@@/shared/text/span";
import { getCurrentStorefrontPath } from "@@/store-fronts/shared/current-store-front";
import { css, cx } from "@emotion/css";
import { useTheme } from "@emotion/react";
import { faPrint } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { RefObject } from "react";
import { useNavigate, useParams } from "react-router";
import { useReactToPrint } from "react-to-print";

type Props = {
    printRef?: RefObject<HTMLDivElement | null>;
    isPaymentPending: boolean;
    nextUrlOverride?: string;
    verifiedByAccessKey?: boolean;
};

const Affirmation = (props: Props) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const nextPath =
        useParams<{ next: string }>().next || getCurrentStorefrontPath();

    const printRef = props.printRef;
    const reactToPrint = useReactToPrint({
        contentRef: printRef,
        pageStyle: "@page { size: a4; margin: 2cm; }",
        bodyClass: cx(
            css({
                overflow: "visible",
                height: "auto",
                width: "100%",
                backgroundColor: "white",
                boxSizing: "border-box",
                justifyContent: "stretch",
                alignItems: "center",
                display: "flex",
                fontFamily: theme.fontFamily,
                fontSize: theme.sizes.base,
                letterSpacing: "0.01em",
                zoom: 0.9,
                userSelect: "none",
            }),
        ),
    });

    if (props.isPaymentPending) return null;
    // if (props.verifiedByAccessKey) return null;

    return (
        <div
            css={{
                position: "relative",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                padding: "0 20px",
                "@media print": {
                    display: "none",
                },
            }}>
            <Column
                crossAxis="center"
                className="w-full max-w-175 space-y-2 rounded-2xl p-5">
                {/* Header */}
                <Column crossAxis="center" className="space-y-5">
                    <Span
                        text={{
                            sv: "Du kommer att få ett mejl som bekräftar din bokning.",
                            en: "You will receive an email confirming your booking.",
                        }}
                        className="px-5 text-center text-xs font-bold text-white opacity-80 text-shadow-md"
                    />
                    <Button
                        variant="ghost"
                        size="sm"
                        className="hover:text-neutral-copy-2 text-neutral-copy-8 w-fit border border-white/40"
                        onClick={() => reactToPrint()}>
                        <Row crossAxis="center" className="space-x-2">
                            <FontAwesomeIcon icon={faPrint} />
                            <Span
                                text={{
                                    sv: "Skriv ut",
                                    en: "Print",
                                }}
                            />
                        </Row>
                    </Button>
                </Column>
                <VerticalDivider XXL />
                <Button
                    variant="primary"
                    className="rounded-4xl px-12 py-7.5 text-center"
                    onClick={() => {
                        if (props.nextUrlOverride?.startsWith("http")) {
                            window.location.href = props.nextUrlOverride;
                            return;
                        }
                        void navigate(props.nextUrlOverride || nextPath || "/");
                    }}>
                    <Span
                        text={{
                            sv: "Fortsätt",
                            en: "Continue",
                        }}
                    />
                </Button>
            </Column>
        </div>
    );
};

export { Affirmation };
